import cx from "classnames";
import React, { useContext } from "react";
import { ToolbarContext } from "./../../ricos-context";
import styles from "./url-link-button-scss";
const AnchorLinkButton = ({ toolbarItem }) => {
  const { isMobile, t } = useContext(ToolbarContext);
  const dataHook = toolbarItem.presentation?.dataHook;
  return /* @__PURE__ */ React.createElement("div", { className: styles.toolbarUrlContainer }, /* @__PURE__ */ React.createElement(
    "button",
    {
      "data-hook": dataHook,
      className: cx(styles.toolbarUrl, styles.toolbarUrlAnchor, isMobile && styles.isMobile),
      onClick: (e) => {
        e.preventDefault();
        toolbarItem.commands.click();
      },
      onMouseDown: (e) => {
        e.preventDefault();
      },
      type: "button"
    },
    t("LinkTo_Toolbar_GoTo")
  ));
};
export {
  AnchorLinkButton
};
//# sourceMappingURL=anchor-link-button.js.map
